export * from './app-sidebar.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-sidebar/index.ts